import Error from './error'

function NotFound({ message }) {
  return (
    <Error status="404" description="La página que estás buscando no se encuentra" />
  )
}

export default NotFound
